/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Checkbox } from "@mui/material";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { AiFillCalendar } from "react-icons/ai";
import { IoLocationSharp } from "react-icons/io5";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import DetailBlock from "../../common/DetailBlock";
import LabelInput from "../../common/LabelInput";
import LabelText from "../../common/LabelText";
import Body from "../../components/Body";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { getOrganizationByid } from "../../stores/OrganizationStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLocations } from "../../stores/LocationStore";

const formInit = {
  contractId: "",
  organization: "",
  agreementDate: new Date(),
  poRequestLocation: "",
  contractStartDate: "",
  contractEndDate: "",
  clientName: "",
  clientDesignation: "",
  contractorName: "A. Zameer",
  contractorDesignation: "Director of Operations",
  tax: config.HST,
  location: "",
  noPo: false,
};

const checkList_1_init = [
  {
    name: "Clean all the entrance areas and lobby",
    value: "Daily",
    checked: true,
  },
  {
    name: "Vacuum carpeted Areas",
    value: "Weekly/As needed",
    checked: true,
  },
  {
    name: "Elevator area complete cleaning",
    value: "Daily",
    checked: true,
  },
  {
    name: "Garbage chute area complete cleaning",
    value: "Daily",
    checked: true,
  },
  {
    name: "Sweep and mop the floors [Laundry Rooms, Lobby, and Hallways & Stains",
    value: "Daily",
    checked: true,
  },
  {
    name: "Clean the washer and dryer",
    value: "Daily or Bi weekly",
    checked: true,
  },
  {
    name: "Sweep and remove soil and or leave in the entrance area",
    value: "Daily",
    checked: true,
  },
  {
    name: "Clean and dust of all areas (light, post Boxes, Entrance Areas, inside doors Areas Heaters & Inside Windows",
    value: "weekly or as needed",
    checked: true,
  },
  {
    name: "Inside windows",
    value: "weekly or as needed",
    checked: true,
  },
  {
    name: "Spot cleaning the high contract areas such as walls, entrance doors and baseboards",
    value: "As needed",
    checked: true,
  },
  {
    name: "Clean dust stair-banister",
    value: "Weekly or as needed",
    checked: true,
  },
  {
    name: "Report unusual incident, damage or malfunction",
    value: "",
    checked: true,
  },
];

const checkList_2_init = [
  {
    name: "Client agrees to provide cleaning materials and equipment needed for the performance of these duties",
    value:
      "Client agrees to provide cleaning materials and equipment needed for the performance of these duties",
    checked: false,
  },
  {
    name: "Contractor agrees to provide cleaning materials and equipment needed for the performance of these duties",
    value:
      "Contractor agrees to provide cleaning materials and equipment needed for the performance of these duties",
    checked: false,
  },
];

function ContractsCreate() {
  const navigate = useNavigate();
  const location = useLocation();
  const [disabled, setDisabled] = useState(false);
  // FIXED: Use single state for list one
  const [listOne, setListOne] = useState([...checkList_1_init]);
  const [listTwo, setListTwo] = useState([...checkList_2_init]);
  const { data: init } = location?.state;
  const queryClient = useQueryClient();

  const { data: organization } = useQuery({
    queryFn: () => getOrganizationByid(init._id),
    queryKey: ["organization", init._id],
  });

  const { data: locationsData } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const [form, setForm] = useState(
    cloneDeep({
      ...formInit,
      organization: organization?.name,
      organizationName: init.name,
      poRequestLocation: init.billingAddress,
    })
  );

  const handleSubmit = async (event) => {
    const frm = {
      ...form,
      organization: init._id,
      location: form.location,
      checkListOne: listOne
        .filter((i) => i.checked)
        .map((i) => ({ ...i, value: i.value === i.name ? "" : i.value })),
      checkListTwo: listTwo
        .filter((i) => i.checked)
        .map((i) => ({ ...i, value: i.value === i.name ? "" : i.value })),
    };

    const res = await api.post("/contracts", frm);
    if (res.ok) {
      queryClient.invalidateQueries(["contracts"]);
      toast.success("Contract has been successfully created.");

      navigate(`/organizations/contracts/${init._id}`, {
        state: { data: cloneDeep(location.state.data) },
      });
    } else {
      return toast.error(res.originalError.message);
    }
  };

  const handleChange = ({ target }) => {
    const name = target.name;
    const value = target.value;
    if (name === "jobStartDate") {
      if (new Date(form.jobEndDate).valueOf() < new Date(value).valueOf()) {
        delete form.jobEndDate;
      }
    }
    setForm({ ...form, [name]: value });
  };

  const handleSelect = ({ target }) => {
    const name = target.name;
    const value = target.value;
    setForm({
      ...form,
      [name]: value,
      attention: value.length ? `${value[0]?.incharge}\n${value[0]?.tag}` : "",
    });
  };

  useEffect(() => {
    genID();
  }, []);

  const genID = async () => {
    const res = await api.get("generate/contract");
    if (!res.ok) return toast.error(res.originalError.message);
    setForm({ ...form, contractId: res.data });
  };

  const {
    contractId: jobId,
    poRequestLocation,
    agreementDate,
    jobStartDate: contractStartDate,
    jobEndDate: contractEndDate,
    tax,
    attention,
    helpText,
    location: loc,
    noPo,
  } = form;

  const size = config.iconSize;
  const locations = organization?.locations?.map((loc) => {
    const found = locationsData?.find((item) => item._id === loc);
    return found;
  });

  // FIXED: Update handleAddMore to add to listOne
  const handleAddMore = () => {
    setListOne((list) => [
      ...list,
      {
        name: "",
        value: "",
        checked: false,
        editableTitle: true,
      },
    ]);
  };

  // FIXED: Update handlers to work with listOne directly
  const handleChangeTitle_one = (ind, value) => {
    const newList = [...listOne];
    newList[ind] = { ...newList[ind], name: value };
    setListOne(newList);
  };

  const handleChangeTitle_two = (ind, value) => {
    const newList = [...listTwo];
    newList[ind] = { ...newList[ind], name: value };
    setListTwo(newList);
  };

  const handleChangeChecklist_one = (ind, event) => {
    const { value } = event.target;
    const newList = [...listOne];
    newList[ind] = {
      ...newList[ind],
      value,
    };
    setListOne(newList);
  };

  const handleChangeChecklist_two = (ind, event) => {
    const { value } = event.target;
    const newList = [...listTwo];
    newList[ind] = {
      ...newList[ind],
      value,
    };
    setListTwo(newList);
  };

  const handleCheked_one = (ind, checked) => {
    const newList = [...listOne];
    newList[ind] = { ...newList[ind], checked };
    setListOne(newList);
  };

  const handleCheked_two = (ind, checked) => {
    const newList = [...listTwo];
    newList[ind] = { ...newList[ind], checked };
    setListTwo(newList);
  };

  return (
    <Body title="Create Contract">
      <form onSubmit={handleSubmit} noValidate={false}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <DetailBlock
              style={{
                boxShadow: "none",
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  marginBottom: 30,
                }}
              >
                <LabelText columnMode label="Contract ID" value={jobId} />
                <LabelText
                  columnMode
                  label="Client"
                  value={organization?.name}
                />
                <LabelText
                  columnMode
                  label="PO Request Location"
                  value={poRequestLocation}
                />
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div className="d-flex justify-content-center">
                <div
                  className="d-flex"
                  style={{
                    width: 800,
                    flexWrap: "wrap",
                    gap: "0px 40px",
                    justifyContent: "center",
                    marginBottom: 30,
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "space-between",
                      width: 800,
                      gap: 20,
                    }}
                  >
                    <AppInput
                      type="date"
                      label="Agreement Date"
                      onChange={handleChange}
                      name="agreementDate"
                      placeholder="Agreement Date"
                      value={agreementDate}
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                      floatLabel
                      required
                    />
                    <AppInput
                      onChange={handleChange}
                      name="contractStartDate"
                      label="Contract Start Date"
                      datePicker
                      floatLabel
                      value={form.contractStartDate}
                      required
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                    <AppInput
                      onChange={handleChange}
                      name="contractEndDate"
                      label="Contract End Date"
                      placeholder="Contract End Date"
                      datePicker
                      minDate={contractStartDate}
                      value={form.contractEndDate}
                      required
                      floatLabel
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                  </div>
                  <AppInput
                    type="multi"
                    label="Job Location"
                    name="location"
                    chip
                    onChange={handleSelect}
                    leftIcon={<IoLocationSharp size={size} color={"silver"} />}
                    style={{ width: 800 }}
                    options={locations
                      ?.filter((i) => i !== undefined)
                      ?.map((i) => {
                        return {
                          ...i,
                          name: `${i.tag} - ${i.title}`,
                        };
                      })}
                    filterBy="name"
                    value={loc}
                    required
                    floatLabel
                  />

                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "space-between",
                      width: 800,
                      gap: 20,
                    }}
                  >
                    <AppInput
                      name="working_days_in_a_week"
                      label="Day of work in a week"
                      floatLabel
                      onChange={handleChange}
                      value={form.working_days_in_a_week}
                    />
                    <AppInput
                      name="working_hours_in_a_week"
                      label="Working hours in a week"
                      floatLabel
                      onChange={handleChange}
                      value={form.working_hours_in_a_week}
                    />
                    <AppInput
                      onChange={handleChange}
                      name="monthly_payment_cost"
                      label="Monthly payment cost"
                      value={form.monthly_payment_cost}
                      floatLabel
                    />
                  </div>
                </div>
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div>
                <LabelInput
                  onChange={handleChange}
                  forceLabel={<b>Invoice Detail</b>}
                  multiline
                  name="invoice_text"
                  style={{ maxWidth: "100%", minHeight: 100 }}
                  value={form.invoice_text}
                />
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              {" "}
              <div>
                <h5 style={{ fontWeight: "bolder" }}>Client Signing details</h5>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>
                      Name of the Authorized Signing Officer :
                    </label>
                    <AppInput
                      label="Name"
                      autoFocus
                      name="clientName"
                      onChange={handleChange}
                      floatLabel
                      value={form.clientName}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>Designation : </label>
                    <AppInput
                      label="Designation"
                      autoFocus
                      name="clientDesignation"
                      onChange={handleChange}
                      floatLabel
                      value={form.clientDesignation}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                </div>
              </div>
              <br />
              <div>
                <h5 style={{ fontWeight: "bolder" }}>
                  Signing Details of A2Z Professional Cleaning & Maintenance
                  Inc.
                </h5>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>
                      Name of the Authorized Signing Officer :
                    </label>
                    <AppInput
                      label="Name"
                      autoFocus
                      name="contractorName"
                      onChange={handleChange}
                      floatLabel
                      value={form.contractorName}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>Designation : </label>
                    <AppInput
                      label="Designation"
                      autoFocus
                      name="contractorDesignation"
                      onChange={handleChange}
                      floatLabel
                      value={form.contractorDesignation}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                </div>
              </div>
            </DetailBlock>

            <DetailBlock style={{ width: 1200 }}>
              {listOne.map((dt, ind) => {
                return (
                  <CheckListItem
                    onChange={(event) => handleChangeChecklist_one(ind, event)}
                    onChangeTitle={(value) => handleChangeTitle_one(ind, value)}
                    onChecked={(value) => handleCheked_one(ind, value)}
                    key={ind}
                    ind={ind}
                    checked={dt.checked}
                    {...dt}
                  />
                );
              })}
              <AppButton
                text="Add More"
                type="button"
                onClick={handleAddMore}
              />
            </DetailBlock>

            <DetailBlock style={{ width: "100%" }}>
              {listTwo.map((dt, ind) => {
                return (
                  <CheckListItem
                    onChange={(event) => handleChangeChecklist_two(ind, event)}
                    onChangeTitle={(value) => handleChangeTitle_two(ind, value)}
                    onChecked={(value) => handleCheked_two(ind, value)}
                    key={ind}
                    ind={ind}
                    extra={false}
                    {...dt}
                  />
                );
              })}
            </DetailBlock>
          </div>

          <div style={{ margin: "20px 0px" }}>
            <AppButton
              disabled={disabled}
              type="button"
              onClick={handleSubmit}
              text="Create Contract"
              className="btn-primary"
            />
          </div>
        </div>
      </form>
    </Body>
  );
}

const CheckListItem = ({
  value,
  onChange,
  name,
  onChecked,
  editableTitle,
  height = 60,
  onChangeTitle,
  checked,
  extra = true,
}) => {
  const [enabled, setEnabled] = useState(checked);

  useEffect(() => {
    setEnabled(checked);
  }, [checked]);

  return (
    <div className="d-flex align-items-center">
      <div>
        <Checkbox
          onClick={() => {
            const newEnabled = !enabled;
            setEnabled(newEnabled);
            if (onChecked) {
              onChecked(newEnabled);
            }
          }}
          checked={enabled}
        />
      </div>
      <AppInput
        onChange={(event) => {
          if (onChangeTitle) {
            onChangeTitle(event.target.value);
          }
        }}
        disabled={!enabled}
        value={name}
        readOnly={!editableTitle}
        multiline
        type="textArea"
        style={{
          border: "none",
          resize: "none",
          height: height,
          backgroundColor: "#00000010",
          overflow: "hidden",
        }}
      />
      <div style={{ width: 200, visibility: extra ? "visible" : "hidden" }}>
        <AppInput
          autoFocus={enabled}
          onChange={onChange}
          disabled={!enabled}
          placeholder="(                  )"
          style={{ height: height }}
          value={value}
        />
      </div>
    </div>
  );
};

export default observer(ContractsCreate);
